<template>
  <div class="content">
    <div class="md-layout-item md-size-100 text-right">
      <md-button class="md-raised md-success mr-4" @click="reviewsModal('new', {})">New Reviews</md-button>
    </div>
    <div class="md-layout">
      <div v-for="review in allReviews" class="blog_item md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-25">
        <stats-card >
          <template slot="header">
            <md-menu md-direction="bottom-start">
              <md-icon md-menu-trigger class="blog_icon">more_vert</md-icon>
              <md-menu-content>
                <md-menu-item @click="reviewsModal('edit', review)">Edit</md-menu-item>
                <md-menu-item @click="deleteReview(review.id)">Delete</md-menu-item>
              </md-menu-content>
            </md-menu>
          </template>
          <template slot="content">
            <h4 class="title py-2">
              {{review.first_name}} {{review.last_name}}
            </h4>
<!--            <p class="category truncate-text">{{review.short_description}}</p>-->
          </template>
          <template slot="footer">
            <div class="stats pb-2">
              <p class="truncate-text">{{review.message}}</p>
            </div>
          </template>
        </stats-card>
      </div>
    </div>
    <!-- dialog-->
    <md-dialog :md-active.sync="showDialog" class="custom-dialog md-size-100">
      <md-dialog-title>{{modalText.title}} Review</md-dialog-title>
      <div class="md-layout-item md-small-size-100 md-size-100 px-4">
        <md-field class="mb-1">
          <label>First Name</label>
          <md-input v-model="modalData.first_name" type="text" required md-placeholder="First Name"></md-input>
        </md-field>
        <span class="text-danger" v-if="modalErrors.first_name">
          {{modalErrors.first_name[0]}}
        </span>
      </div>

      <div class="md-layout-item md-small-size-100 md-size-100 px-4">
        <md-field class="mb-1">
          <label>Last Name</label>
          <md-input v-model="modalData.last_name" type="text" required md-placeholder="Last Name"></md-input>
        </md-field>
        <span class="text-danger" v-if="modalErrors.last_name">
          {{modalErrors.last_name[0]}}
        </span>
      </div>

      <div class="md-layout-item md-small-size-100 md-size-100 px-4">
        <md-field maxlength="8" class="mb-1">
          <label>Message</label>
          <md-textarea v-model="modalData.message" required placeholder="Message"></md-textarea>
        </md-field>
        <span class="text-danger" v-if="modalErrors.message">
          {{modalErrors.message[0]}}
        </span>
      </div>
      <md-dialog-actions class="m-3">
        <md-button class="md-secondary" @click="showDialog = false">Close</md-button>
        <md-button class="md-success" @click="onConfirm()" >{{modalText.btnText}} Review</md-button>
      </md-dialog-actions>
    </md-dialog>
    <!-- dialog-->

    <!-- del   -->
    <md-dialog :md-active.sync="showDelDialog" class="custom-dialog">
      <md-dialog-title>Delete Review</md-dialog-title>
      <div class="md-layout-item md-small-size-100 md-size-100">
        <h4>Are you sure you want to delete this review?</h4>
        <br>
        <p>This action cannot be undone and the review details will be permanently removed.</p>
      </div>
      <md-dialog-actions>
        <md-button class="md-secondary" @click="showDelDialog = false">Close</md-button>
        <md-button class="md-primary" @click="onConfirmDelete()">Delete</md-button>
      </md-dialog-actions>
    </md-dialog>
    <!--    -->
  </div>
</template>

<script>
import {StatsCard} from "@/components";
import {mapActions} from "vuex";

export default {
  name: "AdminReviews",
  data() {
    return {
      showDialog: false,
      showDelDialog: false,
      allReviews: [],
      modalErrors: [],
      delReviewId: null,
      modalText: {
        title: '',
        btnText: ''
      },
      modalData: {
        id: '',
        first_name: '',
        last_name: '',
        message: '',
        mode: ''
      },

    }
  },
  components: {
    StatsCard
  },
  created() {
    this.getAllReviews()
  },
  methods: {
    ...mapActions(['getAdminReviews', 'createEditReview', 'removeAdminReview']),
    getAllReviews() {
      this.getAdminReviews()
          .then(res => {
            this.allReviews = res.data.data
          })
    },
    reviewsModal(mode, item) {
      console.log(item, 'hhhh')
      this.showDialog = true
      if(mode == 'new' ) {
        this.modalData.id = ''
        this.modalData.first_name = ''
        this.modalData.last_name = ''
        this.modalData.message = ''
        this.modalData.mode = 'new'
        this.modalText.title = 'New'
        this.modalText.btnText = 'Create'
      } else {
        this.modalText.title = 'Edit'
        this.modalText.btnText = 'Edit'
        this.modalData.mode = 'edit'
        this.modalData.id = item.id
        this.modalData.first_name = item.first_name
        this.modalData.last_name = item.last_name
        this.modalData.message = item.message
      }
    },

    onConfirm() {
      this.modalErrors = []
      this.createEditReview(this.modalData)
          .then(res => {
            if(res.status == 422) {
              this.modalErrors = res.response.data.errors
            } else {
              this.showDialog = false
              this.getAllReviews()
            }
          })
    },
    deleteReview(id) {
      this.delReviewId = id
      this.showDelDialog = true
    },
    onConfirmDelete() {
      this.removeAdminReview(this.delReviewId)
          .then(res => {
            this.showDelDialog = false
            this.getAllReviews()
            console.log(res, 'removeAdminReview')
          })
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep .md-card-content {
  text-align: unset !important;
  & img {
    height: 200px !important;
  }
}

::v-deep .md-card-header {
  float: right !important;
}
::v-deep .blog_item {
  display: flex;
  //height: 450px !important;
}
::v-deep .md-dialog-container {
  max-width: 650px;
  width: 100%;
  max-height: 100%;
  overflow-y: auto;
}
::v-deep .md-card-header {
  padding: 8px !important;
  margin-bottom: 5px !important;
  cursor: pointer;
  & .blog_icon {
    width: 20px !important;
    height: 20px !important;
  }
}

.truncate-text {
  font-size: 17px;
  //display: -webkit-box;
  //-webkit-line-clamp: 2;
  //-webkit-box-orient: vertical;
  //overflow: hidden;
}
</style>
